<template>
  <div class="description">
    <div class="column">
      <img src="@/assets/web/merge.jpg" />
    </div>
  </div>
</template>
<script>
export default {
  name: "Intro",
  data() {
    return {
      infoList: [
        {
          num: 2,
          name: "研发中心",
          sub: "(深圳研发中心和宁波研发中心)",
        },
        {
          num: 1,
          name: "制造工厂",
          sub: "(台州温岭)",
        },
        {
          num: 4,
          name: "跨境独立站",
          sub: "(四方跨境独立站一站式服务平台)",
        },
      ],
    };
  },
};
</script>
<style less scoped>
.description {
  width: 100%;
  .flag {
    width: 90%;
    margin: 10px auto;
    ul {
      display: flex;
      li {
        text-align: center;
        list-style: none;
        width: 30%;
      }
    }
  }
}
.column {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  width: 100%;
}
.column img {
  text-align: center;
  width: 100%;
}
.cloumn2 {
  width: 100%;
}
.cloumn2 img {
  height: 100%;
}
.con {
}
.con .big {
  color: #0598eb;
  font-size: 30px;
  font-weight: bold;
}
.con p {
  height: 10px;
  line-height: 10px;
}
.step1 {
  display: flex;
  justify-content: space-between;
}
.step1 img {
  width: 50%;
}
.step1 .tips {
  width: 40%;
  text-align: center;
}
.step2 {
  width: 100%;
  margin: 0px auto;
}
.step2 img {
  margin-left: 15%;
  width: 70%;
  left: 15%;
}
.step3 {
  width: 100%;
  margin: 0px auto;
}
.step3 img {
  margin-left: 15%;
  width: 70%;
}
.step4 {
  width: 100%;
  margin: 0px auto;
}
.step4 img {
  margin-left: 5%;
  width: 90%;
}
.step5 {
  width: 100%;
  margin: 0px auto;
}
.step5 img {
  margin-left: 5%;
  width: 90%;
}
.step6 {
  width: 100%;
  margin: 0px auto;
}
.step6 img {
  margin-left: 5%;
  width: 90%;
}
.step7 {
  width: 100%;
  margin: 0px auto;
}
.step7 img {
  margin-left: 5%;
  width: 90%;
}
.tips img {
  margin-top: 25%;
  width: 50px;
}
.tips span {
  display: block;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0598eb;
  font-weight: bold;
  font-size: 30px;
}
</style>